import { gql } from '@apollo/client';

export interface AreaPendingPushSummary {
    areaId: number | null;
    areaName: string | null;
    pendingPushCount: number | null;
    newArrivalCount: number | null;
    returnRedispatchCount: number | null;
    pushedCount: number | null;
    dspName: string | null;
}

export const LIST_AREA_PENDING_PUSH_ORDERS = gql`
    query ListAreaPendingPushOrders($batchNumbers: [String!]!, $warehouseId: Long!) {
        listAreaPendingPushOrders(batchNumbers: $batchNumbers, warehouseId: $warehouseId) {
            areaId
            areaName
            pendingPushCount
            newArrivalCount
            returnRedispatchCount
            pushedCount
            dspName
        }
    }
`;

export interface ListAreaPendingPushOrdersResponse {
    listAreaPendingPushOrders: AreaPendingPushSummary[];
}

export interface ListAreaPendingPushOrdersVariables {
    batchNumbers: string[];
    warehouseId: number;
}
